import { createContext } from 'react';

// @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
const AppContext = createContext();

export default AppContext;

export const { Provider, Consumer } = AppContext;
